var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-691 -619)",
    clipPath: "url(#linkedIn_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705 650.352h-4.631v-14.923H705zm-2.316-16.958a2.7 2.7 0 112.683-2.71 2.706 2.706 0 01-2.683 2.71zm19.663 16.958h-4.624v-7.264c0-1.731-.035-3.951-2.409-3.951-2.409 0-2.778 1.881-2.778 3.827v7.389h-4.63v-14.924h4.444v2.036h.065a4.869 4.869 0 014.385-2.41c4.69 0 5.552 3.088 5.552 7.1v8.2z",
    fill: "currentColor"
  }))));
}
export default SvgLinkedIn;